<template>
    <div class="container">
        <Title text="Nuova pratica" :backArrow="true" backVue="dashboard-lab" />
        <div class="form-container">
            <b-form @submit="submit">
                <!-- First row -->
                <div class="d-flex justify-content-between align-items-center form-row">
                    <b-form-group label="Numero Prescrizione" label-for="numero-prescrizione" class="form-group">
                        <b-form-input
                            id="numero-prescrizione"
                            v-model="nPrescrizione"
                            required
                            type="number"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group label="Codice fiscale del paziente" label-for="cod_fisc" class="form-group">
                        <b-form-input
                            id="cod_fisc"
                            v-model="paziente.codice_fiscale"
                            required
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <!-- / First row -->
                <!-- Second row -->
                <div class="d-flex justify-content-between align-items-center form-row">
                    <b-form-group label="Nome del paziente" description="Cognome" class="form-group">
                        <b-form-input
                            v-model="paziente.cognome"
                            required
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="paziente" class="form-group-nome" description="Nome">
                        <b-form-input
                            id="paziente"
                            v-model="paziente.nome"
                            required
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <!-- / Second row -->
                <!-- Third row -->
                <div class="d-flex justify-content-between align-items-center form-row">
                    <b-form-group label="Dottore" label-for="dottore" class="form-group">
                        <b-form-select
                            id="dottore"
                            v-model="dottore"
                            :options="dottori"
                            required
                        ></b-form-select>
                    </b-form-group>
                    <b-form-group label="Data della prescrizione" label-for="data" class="form-group">
                        <b-form-input
                            id="data"
                            v-model="data"
                            required
                            type="date"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <!-- / Third row -->
                <!-- Fourth row -->
                <div class="d-flex justify-content-between align-items-center form-row">
                    <b-form-group label="Laboratorio" label-for="labs" class="form-group">
                        <b-form-select
                            id="labs"
                            v-model="laboratorio"
                            :options="laboratori"
                            required
                        ></b-form-select>
                    </b-form-group>
                </div>
                <!-- / Fourth row -->
                <!-- Submit button -->
                <div class="button-container" >
                    <b-overlay
                        :show="busy"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="success"
                        class="d-inline-block"
                    >
                        <ButtonPrimary :text="'Fatto'" :front_arrow="true" class="done-button" />
                    </b-overlay>
                </div>
                <!-- / Submit button -->
            </b-form>
        </div>
    </div>
</template>

<script>
import Title from '@/components/Title.vue'
import ButtonPrimary from '@/components/Button-Primary.vue'
import { mixins } from "@/mixins";

export default {
    name: "CreatePratica",
    components: {
        Title,
        ButtonPrimary
    },
    mixins: [mixins],
    data () {
        return {
            nPrescrizione: null,
            nomePratica: '',
            paziente: {
                nome: '',
                cognome: '',
                codice_fiscale: '',
            },
            dottore: null,
            data: new Date().toJSON().slice(0,10),
            dottori: [{value: null, text: "Selezionare un'opzione"}],
            laboratori: [{value: null, text: "Selezionare un'opzione"}],
            laboratorio: null,
            busy: false
        }
    },
    mounted () {
        this.$axios
            .get(this.$apibase + '/api/users/get_dottori/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then(response => {
                var instance;
                for (instance of response.data){
                    this.dottori.push(
                        {value: instance, text: instance.first_name + " " + instance.last_name }
                    )
                }
            })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
        this.$axios
            .get(this.$apibase + '/api/users/get_labs/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then(response => {
                var instance;
                for (instance of response.data){
                    this.laboratori.push(
                        {value: instance, text: instance.first_name + " " + instance.last_name }
                    )
                }
            })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e.response);
            })
    },
    methods: {
        submit: function(evt){
            evt.preventDefault()
            this.busy = true;
            this.$axios
                .post(this.$apibase + '/api/pazienti/paziente/create_pratica_paziente_check/',
                    {
                        nome: this.paziente.nome,
                        cognome: this.paziente.cognome,
                        codice_fiscale: this.paziente.codice_fiscale,
                    },
                    {
                        headers: {
                            Authorization:"JWT " + localStorage.getItem('access_token')
                        }
                    },
                )
                .then(paziente => {
                    // this.$axios.get(this.$apibase + '/api/users/get_username/', {
                    //     headers: {
                    //         Authorization:"JWT " + localStorage.getItem('access_token')
                    //     }
                    // })
                    // .then (username => {
                    this.$axios
                        .post(this.$apibase + '/api/pratica/create_pratica/', 
                            {
                                nuova_pratica: {
                                    nome: paziente.data.nome + " " + paziente.data.cognome + " - " + this.nPrescrizione,
                                    numero_prescrizione: this.nPrescrizione,
                                    paziente: this.$apibase + '/api/pazienti/paziente/' + paziente.data.uid + '/',
                                    dottore: this.$apibase + '/api/users/' + this.dottore.uid + '/',
                                    data_prescrizione: this.data,
                                    laboratorio: this.$apibase + '/api/users/' + this.laboratorio.uid + '/',
                                },
                                dottore_id: this.dottore.uid,
                                paziente_id: paziente.data.uid
                            },
                            {
                                headers: {
                                    Authorization:"JWT " + localStorage.getItem('access_token')
                                }
                            }
                        )
                        .then( () => {
                            this.$store.dispatch('setAlert', {message: "Pratica \"" + this.nomePratica + "\" è stata creata con successo.", type: 'success'});
                            this.$router.push('/dashboard');
                        })
                        .catch( e => {
                            if (e.response.status == 403)
                                this.logout();
                            else
                                alert(e.response);
                        })
                    })
                    .catch( e => {
                        if (e.response.status == 403)
                            this.logout();
                        else
                            alert(e.response);
                    })
                // })
                // .catch(e => {
                //     console.log(e.response)
                // })
        }
    }

}
</script>

<style scoped>
    .container {
        width: 70%;
        max-width: 800px;
    }
    .form-container{
        padding-top: 10px;
        text-align: left;
    }
    .form-group{
        width: 300px;
    }
    .form-group-nome{
        padding-top: 24px;
    }
    .form-row{
        padding-top:30px;
    }
    .button-container {
        padding-top: 50px;
    }
    .done-button {
        height: 40px;
        width: 120px;
    }
</style>